import { required, decimal, integer } from '@vuelidate/validators'

export const UpdateTariff = {
    zoneId: { required },
    typeId: { required },
    weight: { required, decimal },
    minimumPrice: { integer },
    cost: { integer },
}
